import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/about/1.jpg'
import _imports_1 from '@/assets/images/about/2.jpg'
import _imports_2 from '@/assets/images/about/3.jpg'
import _imports_3 from '@/assets/images/about/4.jpg'


const _withScopeId = n => (_pushScopeId("data-v-ae3171a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "about__info" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "Кто мы"),
  /*#__PURE__*/_createElementVNode("p", { class: "about__info-text" }, " Мы - команда профессионалов своего дела. Наше упорство и опыт, накопленный годами, позволяют быстро добиваться качественного результата. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about__photo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "our work"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "our work"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "our work"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "our work"
  })
], -1))
const _hoisted_5 = { class: "interactive-map" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ymap_marker = _resolveComponent("ymap-marker")!
  const _component_yandex_map = _resolveComponent("yandex-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_yandex_map, {
          settings: _ctx.settings,
          coords: [55.66412616, 38.02144699],
          zoom: 16,
          controls: ['geolocationControl','zoomControl','rulerControl']
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ymap_marker, {
              "marker-id": "21",
              "marker-type": 'Placemark',
              coords: [55.66331939, 38.02286345],
              properties: {iconCaption: 'Мойка'}
            }, null, 8, ["coords"]),
            _createVNode(_component_ymap_marker, {
              "marker-id": "12",
              "marker-type": 'Placemark',
              coords: [55.66478459, 38.02145389],
              properties: {iconCaption: 'Сервис'}
            }, null, 8, ["coords"])
          ]),
          _: 1
        }, 8, ["settings", "coords"])
      ])
    ])
  ]))
}